import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { Modal, Input, H3, Text } from '@bigcommerce/big-design';

import { markPOPaid } from '../../redux/actions/purchaseOrders';

const MarkPaidModal = ({ payload, showMarkPaidModal, setShowMarkPaidModal, purchaseOrder, markPaid }) => {
  const update = () => {
    markPaid(payload, purchaseOrder.id);
    setShowMarkPaidModal(false);
  }

  return(
    <>
      { purchaseOrder &&
        <Modal
          actions={[
            {
              text: 'Cancel',
              variant: 'subtle',
              onClick: () => setShowMarkPaidModal(false),
            },
            { text: 'Mark Paid', onClick: () => update() },
          ]}
          closeOnClickOutside={true}
          closeOnEscKey={true}
          header="Mark Paid"
          isOpen={showMarkPaidModal}
          onClose={() => setShowMarkPaidModal(false)}
        >
          <H3>{purchaseOrder.invoice_number || purchaseOrder.id}</H3>
          <Text>Confirm that payment has been sent for this purchase order?</Text>
        </Modal>
      }
    </>
  )
}

const mapStateToProps = state => ({ 
});

const mapDispatchToProps = (dispatch) => ({
  markPaid: (payload, purchaseOrderId) => dispatch(markPOPaid(payload, purchaseOrderId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MarkPaidModal);